import { apiWithToken } from '../api';

const resouceUrl = '/lista_documento';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, lista_documento) => {
  return await api.put(`${resouceUrl}/${id}`, lista_documento);
}

export const store = async (lista_documento) => {
  let response = await api.post(resouceUrl , lista_documento);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}

export const activate = async (id) => {
  return await api.post(`${resouceUrl}/${id}/activate`);
}

export const forceDelete = async (id) => {
  return await api.delete(`${resouceUrl}/${id}/delete`);
}

export const import_data = async (tipo_licenca_id, data_file_csv) => {
  let formData = new FormData();
  formData.append('arquivo', data_file_csv);
  formData.append('tipo_licenca_id', tipo_licenca_id);

  return await api.post(`${resouceUrl}/import_data`,
    formData,
    tipo_licenca_id
    , {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}